// ABOUTME: Warehouse Settings → Integrations → OpenAPI page.
// ABOUTME: Hosts the openapi keys datagrid inside TabView3.
import { Box, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { useTranslation } from "react-i18next";

import { tokens } from "../../../../../theme";
import TabView3 from "../../../../../components/theme/TabView3/TabView3";
import { useTopbar } from "../../../../../contexts/TopbarProvider";
import All from "./views/All";
import { settingsIntegrationsOpenapiConfig } from "./settingsIntegrationsOpenapiConfig";

const Openapikeys = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { showExtraTitle, clearExtraTitle } = useTopbar();

    useImperativeHandle(ref, () => ({}));

    useEffect(() => {
        showExtraTitle(t("openapi_keys"));
        return () => clearExtraTitle();
    }, [showExtraTitle, clearExtraTitle, t, i18n.language]);

    return (
        <Box
            sx={{
                width: 1,
                paddingTop: 9,
                position: "relative",
                "@media screen and (max-width:47.9375em)": {
                    width: 1,
                    marginTop: 9,
                    height: "calc(100% - 72px)",
                    paddingX: 4,
                    paddingTop: 0,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                },
                "@media screen and (max-width: 47.9375em)": {
                    paddingX: 0,
                    background: colors.bg["tertiary"],
                    "&:before,&:after": { display: "none" },
                },
            }}
        >
            <TabView3
                tabConfig={settingsIntegrationsOpenapiConfig}
                sx={{
                    minHeight: "calc(100%)",
                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    position: "relative",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    "&:before": {
                        content: "''",
                        display: "block",
                        position: "absolute",
                        left: 0,
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        height: "48px",
                        width: "24px",
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition: "250ms",
                    },
                    "&:after": {
                        content: "''",
                        display: "block",
                        position: "absolute",
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        right: 0,
                        height: "48px",
                        width: "24px",
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform: "scaleX(-1)",
                        transition: "250ms",
                    },
                    "@media screen and (max-width: 47.9375em)": {
                        "&:before, &:after": { top: 0 },
                    },
                }}
            >
                <All config={settingsIntegrationsOpenapiConfig.all} />
            </TabView3>
        </Box>
    );
});

export default Openapikeys;
